export const ExcludesFalse = (Boolean as any) as <T>(x: T | boolean | null | undefined) => x is T;
/** Remove falsey values from the list, ensuring typescript handles the Types nicely */
export function filterEmpty<T>(x: (T | false | null | undefined)[]): T[] {
	return x.filter(ExcludesFalse); // as T[];
}
